export const mockData = {
  services: [
    {
      id: 1,
      title: "Construcción Residencial",
      description: "Proyectos residenciales personalizados con los más altos estándares de calidad y atención al detalle.",
      icon: "Home",
      image: "https://images.unsplash.com/photo-1694521787193-9293daeddbaa?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjB3b3JrZXJzfGVufDB8fHx8MTc2Mjk4MTM0N3ww&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 2,
      title: "Remodelación General",
      description: "Renovaciones completas y reparaciones generales para transformar tus espacios con calidad profesional.",
      icon: "Paintbrush",
      image: "https://images.unsplash.com/photo-1558227691-41ea78d1f631?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxjb25zdHJ1Y3Rpb24lMjB3b3JrZXJzfGVufDB8fHx8MTc2Mjk4MTM0N3ww&ixlib=rb-4.1.0&q=85"
    },
    {
      id: 3,
      title: "Construcción Comercial",
      description: "Contratistas generales para proyectos comerciales ejecutados con profesionalismo e integridad.",
      icon: "Building2",
      image: "https://images.pexels.com/photos/1216589/pexels-photo-1216589.jpeg"
    }
  ],
  
  projects: [
    {
      id: 1,
      title: "Cocina Moderna",
      category: "Remodelación",
      image: "https://images.unsplash.com/photo-1556912167-f556f1f39fdf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBraXRjaGVufGVufDB8fHx8MTc2MzA0NzQ0NXww&ixlib=rb-4.1.0&q=85",
      description: "Remodelación completa de cocina con acabados de lujo"
    },
    {
      id: 2,
      title: "Cocina Contemporánea",
      category: "Remodelación",
      image: "https://images.unsplash.com/photo-1600489000022-c2086d79f9d4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBraXRjaGVufGVufDB8fHx8MTc2MzA0NzQ0NXww&ixlib=rb-4.1.0&q=85",
      description: "Diseño minimalista con isla central"
    },
    {
      id: 3,
      title: "Cocina Elegante",
      category: "Remodelación",
      image: "https://images.unsplash.com/photo-1628745277862-bc0b2d68c50c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBraXRjaGVufGVufDB8fHx8MTc2MzA0NzQ0NXww&ixlib=rb-4.1.0&q=85",
      description: "Espacio abierto con acabados premium"
    },
    {
      id: 4,
      title: "Baño Spa",
      category: "Remodelación",
      image: "https://images.unsplash.com/photo-1638799869566-b17fa794c4de?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBiYXRocm9vbXxlbnwwfHx8fDE3NjMwNDc0NTZ8MA&ixlib=rb-4.1.0&q=85",
      description: "Baño principal con diseño tipo spa"
    },
    {
      id: 5,
      title: "Baño Moderno",
      category: "Remodelación",
      image: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBiYXRocm9vbXxlbnwwfHx8fDE3NjMwNDc0NTZ8MA&ixlib=rb-4.1.0&q=85",
      description: "Remodelación con acabados contemporáneos"
    },
    {
      id: 6,
      title: "Edificio Residencial",
      category: "Construcción",
      image: "https://images.pexels.com/photos/2724749/pexels-photo-2724749.jpeg",
      description: "Proyecto de construcción residencial completado"
    },
    {
      id: 7,
      title: "Casa Moderna",
      category: "Construcción",
      image: "https://images.pexels.com/photos/1571462/pexels-photo-1571462.jpeg",
      description: "Vivienda unifamiliar con arquitectura contemporánea"
    },
    {
      id: 8,
      title: "Proyecto Residencial",
      category: "Construcción",
      image: "https://images.unsplash.com/photo-1760331840595-72c9681e7e71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxyZW5vdmF0aW9uJTIwcHJvamVjdHN8ZW58MHx8fHwxNjMwNDc0Mzl8MA&ixlib=rb-4.1.0&q=85",
      description: "Renovación integral de propiedad"
    }
  ],
  
  testimonials: [
    {
      id: 1,
      name: "María González",
      role: "Propietaria",
      content: "Excelente trabajo en la remodelación de nuestra cocina. Profesionales, puntuales y atentos a cada detalle. ¡Superó nuestras expectativas!",
      rating: 5,
      image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Maria"
    },
    {
      id: 2,
      name: "Carlos Rodríguez",
      role: "Empresario",
      content: "Construyeron nuestro local comercial con excelente calidad y en el tiempo acordado. Muy recomendados para proyectos comerciales.",
      rating: 5,
      image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Carlos"
    },
    {
      id: 3,
      name: "Ana Martínez",
      role: "Arquitecta",
      content: "He trabajado con Copal en varios proyectos. Su compromiso con la calidad y atención al cliente es excepcional. Un equipo de confianza.",
      rating: 5,
      image: "https://api.dicebear.com/7.x/avataaars/svg?seed=Ana"
    }
  ],
  
  stats: [
    { label: "Años de Experiencia", value: "15+" },
    { label: "Proyectos Completados", value: "200+" },
    { label: "Clientes Satisfechos", value: "150+" },
    { label: "Equipo Profesional", value: "25+" }
  ],
  
  contactInfo: {
    email: "copalenterprisesllc@gmail.com",
    phone: "972-607-6035",
    address: "Dallas, Texas",
    socialMedia: {
      facebook: "https://facebook.com/copalenterprises",
      instagram: "https://instagram.com/copalenterprises"
    }
  },
  
  brandInfo: {
    tagline: "Renovation made easy!",
    mission: "Proporcionar el trabajo de la más alta calidad posible, enfocándonos en la calidad sobre la cantidad y prestando atención extra a cada detalle. Priorizamos a nuestros clientes en todo momento.",
    vision: "Convertirnos en la opción preferida de nuestros clientes alcanzando la excelencia en calidad y proyectos de valor agregado completados a tiempo, con una cultura centrada en las personas construida sobre una base de confianza.",
    values: [
      "Integridad y honestidad",
      "Calidad y atención al detalle",
      "Mentalidad centrada en el cliente",
      "Profesionalismo",
      "Trabajo en equipo"
    ]
  }
};
